import React from 'react';
import { Box, Progress } from '@bynder/design-system';
import { IconFullscreen, IconPictureInPicture, IconVideo } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import Loader from 'packages/common/loader/Loader';
import { PortionSelectorLoaderContainer, PortionSelectorLoaderWrapper } from './PortionSelectorLoader.styled';

// TODO: Old code here, need to be refactored.
const PortionSelectorLoader = ({ type, processProgress }) => {
    const { translate } = useTranslate();

    return (
        <PortionSelectorLoaderContainer>
            <PortionSelectorLoaderWrapper>
                <div className={`portion--selector-fake-player ${type === 'audio' ? 'fake--player-audio' : ''}`}>
                    <IconVideo size="48" />
                    <div className="portion--selector-fake-controls-panel">
                        <Loader size={24} />
                        <p>{`${translate('portion.selector.processing')} ${type} . ${processProgress}%`}</p>
                        <div className="portion--selector-fake-controls">
                            <span className="portion--selector-fake-control-item">
                                <IconPictureInPicture size="24" />
                            </span>
                            <span className="portion--selector-fake-control-item">
                                <IconFullscreen size="24" />
                            </span>
                        </div>
                    </div>
                </div>
                <div className="portion--selector-fake-duration-container">
                    <div className="portion--selector-fake-duration-header">
                        <h5 className="portion--selector-fake-duration-title">{`${type.replace(
                            type.slice(0, 1),
                            type.charAt(0).toUpperCase(),
                        )} ${translate('portion.selector.duration')}`}</h5>
                        <span className="portion--selector-fake-duration-status">
                            {translate('portion.selector.calculating')}
                        </span>
                    </div>
                    <Box marginBottom="4">
                        <Progress
                            color="brand"
                            width={processProgress}
                            aria-label={`${type.replace(type.slice(0, 1), type.charAt(0).toUpperCase())} ${translate(
                                'portion.selector.duration',
                            )}`}
                        />
                    </Box>
                    <p>{`${translate('portion.selector.trimInProcessingContent')} ${type}.`}</p>
                </div>
            </PortionSelectorLoaderWrapper>
        </PortionSelectorLoaderContainer>
    );
};

export default PortionSelectorLoader;
